"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferTranspiled = inferTranspiled;
function inferTranspiled(c) {
    var _a;
    return (_a = c.transpiled) !== null && _a !== void 0 ? _a : !/^I[A-Z]/.test(c.name);
}
//# sourceMappingURL=infer-transpiled.js.map